// extracted by mini-css-extract-plugin
module.exports = {"content":"meteoinfo_content__tu5Zn","center":"meteoinfo_center__3KJeW"};